module.exports = __webpack_public_path__ + "static/days-of-rage-8ab6bc664298589957c716ce57c2a455.jpg";